export default __webpack_public_path__ + "static/media/Fiche Consciencieux.02f3bd12.pdf";